/**
 * CSV export helper utilities for consistent parent-child quantity conversion
 */

import { getSummaryQuantity } from "./parent-child-conversion";

/**
 * Gets CSV-compatible value with child quantity conversion for specific fields
 * @param {object} shipment - The shipment object
 * @param {string} fieldId - The field identifier  
 * @returns {*} - Child quantity for quantity fields, raw value for others
 */
export const getCsvValue = (shipment, fieldId) => {
    // Apply child quantity conversion for these specific fields
    switch (fieldId) {
        case 'confirmedUnits':
            return getSummaryQuantity(shipment, 'confirmedUnits', 'childConfirmedUnits');
        case 'receivedUnits':
            return getSummaryQuantity(shipment, 'receivedUnits', 'childReceivedUnits');
        case 'nyrnys':
            return getSummaryQuantity(shipment, 'nyrnys', 'childNyrnys');
        case 'asrsConfirmedUnits':
            return getSummaryQuantity(shipment, 'asrsConfirmedUnits', 'childAsrsConfirmedUnits');
        case 'asrsReceivedUnits':
            return getSummaryQuantity(shipment, 'asrsReceivedUnits', 'childAsrsReceivedUnits');
        case 'expectedUnits':
            return getSummaryQuantity(shipment, 'expectedUnits', 'childExpectedUnits');
        case 'expectedAsrsUnits':
            return getSummaryQuantity(shipment, 'expectedAsrsUnits', 'childExpectedAsrsUnits');
        default:
            // For all other fields, use direct access
            const value = shipment[fieldId];
            // Convert arrays to string format for CSV compatibility
            if (Array.isArray(value)) {
                return value.join(' && ');
            }
            return value;
    }
};